import { useEffect, useState } from "react";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../../components/commons";
import AddEditTdsMaster from "../../../components/MasterData/TdsMaster/AddEditTdsMaster";
import {
  TdsInfoType,
  TdsRateType,
  TdsSinglePayloadType,
  UniqueCheckCodePayloadType,
} from "../../../commonTypes/masterDataTypes";
import { TDS_DUMMY_DATA } from "../../../constant/master";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import {
  checkUniqueCode,
  getMasterTdsModuleSingleAction,
  resetCodeFetching,
  resetCodeMessage,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
  updateMasterTdsModuleAction,
} from "../../../redux/masterData";
import { useParams } from "react-router-dom";
import { TDSSingleDetailsType } from "../../../redux/masterData/masterTypes";
import { formatDate } from "../../../utils/commonFunctions";
import toast from "react-hot-toast";
import useDebounce from "../../../customHooks/useDebounce";

type AppProps = {
  token: string | null;
  history: any;
  fetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  tdsSingleData: TDSSingleDetailsType | any;
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchUpdateTdsModuleAction: (data: TdsInfoType) => void;
  dispatchGetSingleTdsDataAction: (data: TdsSinglePayloadType) => void;
  codeFetching: boolean;
  codeMessage: string;
  dispatchCheckUniqueCode: (data: UniqueCheckCodePayloadType) => void;
  dispatchResetCodeFetching: () => void;
  dispatchResetCodeMessage: () => void;
};

const EditTdsMaster = ({
  fetching,
  history,
  message,
  success,
  error,
  token,
  statusCode,
  tdsSingleData,
  dispatchResetMasterError,
  dispatchResetSession,
  dispatchResetMasterSuccess,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  dispatchUpdateTdsModuleAction,
  dispatchGetSingleTdsDataAction,
  codeFetching,
  codeMessage,
  dispatchCheckUniqueCode,
  dispatchResetCodeFetching,
  dispatchResetCodeMessage,
}: AppProps) => {
  const [tdsData, setTdsData] = useState<TdsInfoType>(TDS_DUMMY_DATA);
  const searchValue = history?.location?.state?.searchValue;
  const sortBy = history?.location?.state?.sortBy;

  const { tdsId } = useParams<any>();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetMasterStatusCode();
    dispatchResetCodeFetching();
    dispatchResetCodeMessage();
  }, []);

  useEffect(() => {
    if (token && tdsId) {
      let finalData = {
        token,
        tdsId,
      };
      dispatchGetSingleTdsDataAction(finalData);
    }
  }, [tdsId]);

  useDebounce(
    () => {
      // dispatchResetUniqueCheckAction();
      if (tdsData?.code) {
        let finalData: any = {
          token,
          operation: "update",
          code: tdsData?.code,
          type: "tds",
          id: tdsId,
        };
        dispatchCheckUniqueCode(finalData);
      }
    },
    500,
    [tdsData?.code, tdsId]
  );

  useEffect(() => {
    if (tdsSingleData?.tds_id) {
      const {
        deducte,
        deducte_type,
        nature_of_payment,
        residential_status,
        section_name,
        tds_rates,
        threshold,
        tds_id,
        code,
      } = tdsSingleData;

      let newTdsRates = tds_rates?.map((item: TdsRateType) => {
        return { ...item, tds_date: formatDate(item?.tds_date), isEdit: true };
      });
      setTdsData((prev: any) => ({
        ...prev,
        deducte,
        deducteType: deducte_type,
        natureOfPayment: nature_of_payment,
        residentialStatus: residential_status,
        code: code,
        sectionName: section_name,
        tdsRates: newTdsRates,
        threshold,
        uniqueId: tds_id,
      }));
    }
  }, [tdsSingleData]);

  const handleEditTdsMaster = () => {
    if (
      tdsData?.sectionName?.trim()?.length === 0 ||
      tdsData?.natureOfPayment?.trim()?.length === 0 ||
      tdsData?.tdsRates?.find(
        (item: TdsRateType) => !item?.tds_date || !item?.tds_rate
      )
    ) {
      toast.error("Please fill all mandatory field", {
        duration: 3000,
      });
    } else {
      if (token) {
        let finalData = {
          ...tdsData,
          deducteType: tdsData?.deducte?.Company ? tdsData?.deducteType : "",
          token,
          tdsId,
        };
        dispatchUpdateTdsModuleAction(finalData);
      }
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
              dispatchResetMasterSuccess();
              dispatchResetMasterMessage();
              dispatchResetMasterStatusCode();
            }}
          />
        );
      }
    } else if (
      success === 1 &&
      message === "Tax Deducted at Source has been Updated successfully!"
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={"TDS Updated Successfully"}
          buttonText="OK"
          onPress={() => {
            history?.push({
              pathname: `/master-data/tds-and-tcs-master`,
              state: { searchValue, sortBy },
            });
            dispatchResetMasterError();
            dispatchResetMasterMessage();
            dispatchResetMasterStatusCode();
            dispatchResetMasterSuccess();
          }}
          statusCode={statusCode}
        />
      );
    }
    return false;
  };

  return (
    <div>
      <div className="col-md-6">
        <CommonHeader title="Edit TDS" />
      </div>

      <AddEditTdsMaster
        header={"Edit New TDS Rate"}
        subHeader={"Fill form below to edit entry in TDS"}
        history={history}
        tdsData={tdsData}
        setTdsData={setTdsData}
        handleSubmit={handleEditTdsMaster}
        codeFetching={codeFetching}
        codeMessage={codeMessage}
      />

      {handleErrorModal()}
      {fetching && <Loader />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  success: state.masterData.success,
  message: state.masterData.message,
  tdsSingleData: state.masterData.tdsSingleData,
  codeFetching: state.masterData.codeFetching,
  codeMessage: state.masterData.codeMessage,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchUpdateTdsModuleAction: (data: TdsInfoType) =>
    dispatch(updateMasterTdsModuleAction(data)),
  dispatchGetSingleTdsDataAction: (data: TdsSinglePayloadType) =>
    dispatch(getMasterTdsModuleSingleAction(data)),
  dispatchCheckUniqueCode: (data: UniqueCheckCodePayloadType) =>
    dispatch(checkUniqueCode(data)),
  dispatchResetCodeFetching: () => dispatch(resetCodeFetching()),
  dispatchResetCodeMessage: () => dispatch(resetCodeMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditTdsMaster);
